import type { SearchOrderFormValues } from 'my-purchases/types/searchOrderForm'

export const enum SearchOrderFormFieldNames {
	Email = 'email',
	Order = 'order',
}

export const enum SearchOrderFormSumbitErrors {
	Generic = 'generic',
	Email = 'email',
	Order = 'order',
}

export const enum SearchOrderFormErrorTypes {
	Required = 'required',
	Root = 'root',
	MaxLength = 'maxLength',
	Pattern = 'pattern',
	Validate = 'validate',
}

export const enum SearchOrderFormFieldIds {
	Email = 'myPurchases.login.guest.email.input',
	Order = 'myPurchases.login.guest.orderId.input',
	SubmitButton = 'myPurchases.login.guest.goToDetails',
}

export const defaultValues: SearchOrderFormValues = {
	email: '',
	order: '',
}

export const ORDER_INPUT_VALIDATION = {
	regex: '^[a-zA-Z0-9]{6}$',
	maxLength: 6,
}

export const EMAIL_INPUT_VALIDATION = {
	// It's needed to validate order emails generated through marketplaces, for example Zalando
	// o+123456759@pp-orders.zalan.do
	regex:
		'^([a-zA-Z0-9+_-]+(?:\\.[a-zA-Z0-9+_-]+)*)@((?:[a-zA-Z0-9_-]+\\.)*[a-zA-Z0-9_-]{0,66})\\.([a-zA-Z]{2,6}(?:\\.[a-zA-Z]{2})?)$',
}
